import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import KeyboardArrowDownIcon from 'components/icons/ArrowDown.svg'
import KeyboardArrowUpIcon from 'components/icons/ArrowUp.svg'
import sx from './styles'

const ShowMoreButton = ({ showMore, toggleShowMore }) => {
  return (
    <Box
      textAlign="center"
      mt={2}
    >
      <Button
        endIcon={showMore ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        sx={sx.expandButton}
        onClick={() => toggleShowMore(!showMore)}
      >
        <Typography variant="link-text">
          {showMore ? 'Ver menos' : 'Ver más'}
        </Typography>
      </Button>
    </Box>
  )
}

export default ShowMoreButton
